import React from 'react';
import { useDropzone as useReactDropzone } from 'react-dropzone';
import { useDispatch } from 'react-redux';
import cuid from 'cuid';
import { EditorActions } from 'app/stores/editor/actions';
import { getSupportedMimeTypes } from 'app/utils/upload';
export function useDropzone(options) {
    const dispatch = useDispatch();
    const opts = React.useMemo(() => {
        const supportedMimeTypes = getSupportedMimeTypes();
        const fileMaxSize = configGet('fileUploadMaxSize', 1e6);
        const multiSelectEnabled = configGet('multipleFilesSelectEnabled', false);
        return Object.assign({ accept: supportedMimeTypes.join(', '), maxSize: fileMaxSize, noClick: true, noKeyboard: true, multiple: multiSelectEnabled }, options);
    }, [options]);
    const result = useReactDropzone(opts);
    const { fileRejections } = result;
    React.useEffect(() => {
        if (!fileRejections || !fileRejections.length) {
            return;
        }
        const rejections = fileRejections.map(rejection => {
            var _a;
            return ({
                id: cuid(),
                name: (_a = rejection.file) === null || _a === void 0 ? void 0 : _a.name,
                errors: rejection.errors,
            });
        });
        dispatch(EditorActions.setRejections({ rejections }));
    }, [fileRejections, dispatch]);
    return result;
}
